<template lang="pug">
v-checkbox.app-checkbox(
  v-model="inputValue"
  v-bind="inputAttrs"
  :value="item"
  :class="{ 'app-checkbox--empty-label': !label.length, 'app-checkbox--disabled': disabled }"
  @change="changeValue"
)
  template(#default)
    slot(name="default")
  template(#label)
    slot(name="label" :label="currentLabel")
      p {{ currentLabel }}
  template(#append)
    slot(name="append")
</template>

<script>
// REFACTOR: deprecated, replace with app-checkbox

export default {
  name: 'AppCheckboxOld',

  props: {
    item: { type: [Number, String, Array, Boolean, Object], default: null },
    value: { type: [Number, String, Array, Boolean], default: null },
    required: { type: Boolean, default: false },
    label: { type: String, default: 'label' },
    multiple: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
  },

  computed: {
    inputValue: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit('input', v);
      },
    },
    inputAttrs() {
      const { disabled, currentLabel } = this;
      return {
        color: 'redesignPrimary',
        disabled,
        label: currentLabel,
        'off-icon': '$icheckbox-off',
        'on-icon': '$icheckbox-on',
        ...this.$attrs,
      };
    },
    currentLabel() {
      return `${this.label}${this.required ? '*' : ''}`;
    },
  },

  methods: {
    changeValue(value) {
      if (this.multiple) {
        this.inputValue.push(value);
      } else {
        this.inputValue = value;
      }
      this.$emit('change', value);
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
